// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item-share__dialog{z-index:1000;border-radius:4px}.item-share__dialog .el-dialog__header{padding:14px 20px}.item-share__dialog .el-dialog__body{padding:10px 0 20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
